<template>
    <div class="panel-body">
        <div class="panel-nav">
            <button class="close-button" v-on:click.prevent="closePanel"></button>
        </div>
        <ul id="countries-list" class="scroller">
            <li v-for="_country in countries"
                @click="country=_country">
                <span class="country-icon" v-bind:style="_country.style"></span>
                <span class="country-label">{{ _country.value }}</span>
                <span class="country-number">Aperti <span class="value">{{ _country.stations.open }}</span></span>
            </li>
        </ul>
    </div>
</template>

<script>

    import { serverBus } from '../main';
    import Countries from "../models/countries";

    export default {
        methods: {
            closePanel() {
                serverBus.$emit("closePanel");
            },
            loadData() {
                //FIXME: prendo i parametri dal parent
                this.fuel = this.$parent.$parent.$parent.$parent.fuel;

                var $scope = this;

                if(this.fuel) {
                    Countries.getMarkers(this.fuel, [], function (_countries) {
                        $scope.countries = _countries;
                    });
                }
            }
        },
        data() {
            return {
                fuel: null,
                country: null,
                countries: []
            };
        },
        created() {
            serverBus.$on('areaChanged',this.loadData);
            serverBus.$emit('pageChanged',{page:'CountriesList'});
            this.loadData();
        },
        watch: {
            country: function (val) {
                serverBus.$emit('positionChanged', {
                    country_iso: val.sprite
                });
            }
        }
    }

</script>

<style lang="scss">
#ecomotoriMap {
  #countries-list {
        margin: 0px;
        padding-left: 10px;
        list-style: none;
        text-align: left;
        li {
            height: 40px;
            margin: 10px;
            padding: 10px;
            border-bottom: 1px solid rgb(204,204,204);
            cursor: pointer;
            &:hover {
                background-color: #f3f3f3;
            }
        }
        span {
            height: 40px;
            display: inline-block;
            line-height: 40px;
            vertical-align: top;
        }
        .country-icon {
            width: 40px;
            height: 40px;
            background-size: 100% auto;
        }
        .country-label {
            font-size: 23px;
            text-transform: uppercase;
            color: #0c71b2;
            font-weight: bold;
            margin-left: 20px;
            width: calc(100% - 160px - 20px);
        }
        .country-number {
            position: relative;
            color: #525252;
            font-size: 16px;
            font-weight: bold;
            .value {
                position: absolute;
                right: 0;
                color: #3fa611;
                text-align: right;
            }
            width: 120px;
        }
    }
    }

    @media only screen and (max-width: 620px) {
    #ecomotoriMap {
      #countries-list {
            li {
                zoom: 0.9;
            }
        }
        }
    }

    @media only screen and (max-width: 360px) {
    #ecomotoriMap {
      #countries-list {
            li {
                zoom: 0.70;
            }
        }
        }
    }

</style>
